import { DeleteArcgisCivil3dParcelSettingsApiRequest } from 'types/requests/arcgis-civil3d-settings/parcels/delete-arcgis-civil3d-parcel-settings.request';
import { ArcgisCivil3dParcelSettingApiModel } from '../../../types/models/arcgis-civil3d-parcel-setting.model';
import { CreateArcgisCivil3dParcelSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/create-arcgis-civil3d-parcel-setting.request';
import { GetArcgisCivil3dParcelSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/get-arcgis-civil3d-parcel-setting.request';
import { SearchArcgisCivil3dParcelSettingsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/search-arcgis-civil3d-parcel-settings.request';
import { UpdateArcgisCivil3dParcelSettingApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/update-arcgis-civil3d-parcel-setting.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { ArcgisCivil3dPropertyMappingApiModel } from '../../../types/models/arcgis-civil3d-property-mapping.model';
import { CreatePropertyMappingForParcelApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/create-property-mapping-for-parcel.request';
import { DeletePropertyMappingForParcelApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/delete-property-mapping-for-parcel.request';
import { GetAllPropertyMappingsForParcelApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/get-all-property-mappings-for-parcel.request';
import { UpdatePropertyMappingsForParcelApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/update-property-mappings-for-parcel.request';
import { DuplicateArcgisCivil3dParcelsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/duplicate-arcgis-civil3d-parcel-settings.request';
import { CreatePropertyMappingsForParcelsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/create-property-mappings-for-parcels.request';
import { SearchPropertyMappingsForParcelsApiRequest } from '../../../types/requests/arcgis-civil3d-settings/parcels/search-property-mappings-for-parcels.request';

export const createParcelSetting = (params: CreateArcgisCivil3dParcelSettingApiRequest) =>
  client.post<ArcgisCivil3dParcelSettingApiModel>('/arcgis-civil3d-settings/parcels', params);

export const updateParcelSetting = ({ parcelId, ...params }: UpdateArcgisCivil3dParcelSettingApiRequest) =>
  client.patch<ArcgisCivil3dParcelSettingApiModel>(`/arcgis-civil3d-settings/parcels/${parcelId}`, params);

export const deleteParcelSettings = ({ parcelIds, ...params }: DeleteArcgisCivil3dParcelSettingsApiRequest) =>
  client.delete<ArcgisCivil3dParcelSettingApiModel>(`/arcgis-civil3d-settings/parcels`, {
    data: { parcelIds },
    ...params,
  });

export const duplicateParcelSettings = (params: DuplicateArcgisCivil3dParcelsApiRequest) =>
  client.post<ArcgisCivil3dParcelSettingApiModel[]>(`/arcgis-civil3d-settings/parcels/duplicate`, params);

export const getParcelSetting = <T extends ArcgisCivil3dParcelSettingApiModel>({
  parcelId,
  ...params
}: GetArcgisCivil3dParcelSettingApiRequest) =>
  client.get<T>(`/arcgis-civil3d-settings/parcels/${parcelId}`, { params });

export const searchParcelSettings = <T extends ArcgisCivil3dParcelSettingApiModel>(
  params: SearchArcgisCivil3dParcelSettingsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/parcels`, { params });

export const createPropertyMappingForParcel = ({ parcelId, ...params }: CreatePropertyMappingForParcelApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/parcels/${parcelId}/property-mappings`,
    { params },
  );

export const searchPropertyMappingsForParcels = <T extends ArcgisCivil3dPropertyMappingApiModel>(
  params: SearchPropertyMappingsForParcelsApiRequest,
) => client.get<CursorPaginatedApiResponse<T>>(`/arcgis-civil3d-settings/parcels/property-mappings`, { params });

export const createPropertyMappingsForParcels = (params: CreatePropertyMappingsForParcelsApiRequest) =>
  client.post<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/parcels/property-mappings`,
    params,
  );

export const updatePropertyMappingsForParcel = ({ parcelId, ...params }: UpdatePropertyMappingsForParcelApiRequest) =>
  client.patch<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/parcels/${parcelId}/property-mappings`,
    params,
  );

export const getAllPropertyMappingsForParcel = ({ parcelId }: GetAllPropertyMappingsForParcelApiRequest) =>
  client.get<{ propertyMappings: ArcgisCivil3dPropertyMappingApiModel[] }>(
    `/arcgis-civil3d-settings/parcels/${parcelId}/property-mappings`,
  );

export const deletePropertyMappingFromParcel = ({
  parcelId,
  civil3dPropertyId,
}: DeletePropertyMappingForParcelApiRequest) =>
  client.delete<void>(`/arcgis-civil3d-settings/parcels/${parcelId}/property-mappings/${civil3dPropertyId}`);
